export const updatedDataActionType = {
	UPDATEDDATA: 'UPDATEDDATA',
};
